import _asyncToGenerator from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";

var _process$env$NEXT_PUB, _process$env$NEXT_PUB2, _process$env$NEXT_PUB3;

import _regeneratorRuntime from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/regenerator";
import jwtDecode from 'jwt-decode';
import request from 'superagent';
var backendBaseUrl = (_process$env$NEXT_PUB = process.env.NEXT_PUBLIC_APP_API_BASE_URL) !== null && _process$env$NEXT_PUB !== void 0 ? _process$env$NEXT_PUB : '';
var backendAuthBaseUrl = (_process$env$NEXT_PUB2 = process.env.NEXT_PUBLIC_AWS_COGNITO_POOL_BASE_URL) !== null && _process$env$NEXT_PUB2 !== void 0 ? _process$env$NEXT_PUB2 : '';
var backendAuthClientId = (_process$env$NEXT_PUB3 = process.env.NEXT_PUBLIC_AWS_COGNITO_CLIENT_ID) !== null && _process$env$NEXT_PUB3 !== void 0 ? _process$env$NEXT_PUB3 : '';

var tokenHasExpired = function tokenHasExpired(token) {
  // Less than 10 seconds remaining => token has expired
  var now = new Date().getTime() / 1000;
  return token.exp - now < 10;
};

var Client = /*#__PURE__*/function () {
  function Client(baseUrl, authBaseUrl, authClientId) {
    _classCallCheck(this, Client);

    _defineProperty(this, "baseUrl", void 0);

    _defineProperty(this, "authBaseUrl", void 0);

    _defineProperty(this, "authClientId", void 0);

    _defineProperty(this, "agent", void 0);

    _defineProperty(this, "tokenKey", 'token');

    _defineProperty(this, "site", void 0);

    _defineProperty(this, "isAuthenticated", void 0);

    this.baseUrl = baseUrl;
    this.authBaseUrl = authBaseUrl;
    this.authClientId = authClientId;
    this.agent = request.agent();
    void this.agent.accept('application/json');
    void this.agent.withCredentials();
    this.isAuthenticated = false;
  } // eslint-disable-next-line @typescript-eslint/no-explicit-any


  _createClass(Client, [{
    key: "request",
    value: function () {
      var _request = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(method, endpoint) {
        var _this$site;

        var data,
            checkToken,
            url,
            promise,
            token,
            _yield$promise,
            body,
            _args = arguments;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = _args.length > 2 && _args[2] !== undefined ? _args[2] : null;
                checkToken = _args.length > 3 && _args[3] !== undefined ? _args[3] : true;

                if (!checkToken) {
                  _context.next = 5;
                  break;
                }

                _context.next = 5;
                return this.checkToken();

              case 5:
                url = /^https?:\/\//.test(endpoint) ? endpoint : "".concat(this.baseUrl).concat(endpoint);
                promise = this.agent[method](url);
                token = this.getToken();

                if (token !== null) {
                  promise = promise.set('Authorization', "Bearer ".concat(token));
                }

                promise = promise.set('x-site-id', (_this$site = this.site) !== null && _this$site !== void 0 ? _this$site : '');

                if (data !== null) {
                  if (['post', 'put', 'patch'].includes(method)) {
                    promise = promise.send(data);
                  } else if (['get', 'delete'].includes(method)) {
                    promise = promise.query(data);
                  }
                } // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment


                _context.next = 13;
                return promise;

              case 13:
                _yield$promise = _context.sent;
                body = _yield$promise.body;
                return _context.abrupt("return", body);

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function request(_x, _x2) {
        return _request.apply(this, arguments);
      }

      return request;
    }()
  }, {
    key: "getToken",
    value: function getToken() {
      return localStorage.getItem(this.tokenKey);
    }
  }, {
    key: "updateToken",
    value: function updateToken(token) {
      return localStorage.setItem(this.tokenKey, token);
    }
  }, {
    key: "getRedirectUri",
    value: function getRedirectUri() {
      return "".concat(window.location.protocol, "//").concat(window.location.host, "/login");
    }
  }, {
    key: "redirectToSSO",
    value: function redirectToSSO() {
      var isLogout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.isAuthenticated = false;
      var path = isLogout ? 'logout' : 'login';
      var ssoRedirectUrl = new URL("".concat(this.authBaseUrl, "/").concat(path));
      ssoRedirectUrl.searchParams.append('response_type', 'code');
      ssoRedirectUrl.searchParams.append('scope', 'aws.cognito.signin.user.admin email openid');
      ssoRedirectUrl.searchParams.append('client_id', this.authClientId);
      ssoRedirectUrl.searchParams.append('redirect_uri', this.getRedirectUri()); // Using "state" param to retrieve this value at the end of the login process, see https://docs.aws.amazon.com/cognito/latest/developerguide/login-endpoint.html
      // State object passed as a base64 representation of the stringified object to avoid Cognito parsing it

      var postAuthRedirectUrl = window.location.pathname;
      ssoRedirectUrl.searchParams.append('state', btoa(JSON.stringify({
        redirect_url: postAuthRedirectUrl
      })));
      window.location.replace(ssoRedirectUrl.toString());
    }
    /**
     * This function assess the access token is still valid, if not it refreshes it.
     * In case of error during the refresh process it disconnects the user and redirects to the login page.
     */

  }, {
    key: "checkToken",
    value: function () {
      var _checkToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var token, parsedToken;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                token = this.getToken(); // Redirect to SSO if no token

                if (!(token === null)) {
                  _context2.next = 4;
                  break;
                }

                this.redirectToSSO();
                return _context2.abrupt("return");

              case 4:
                _context2.prev = 4;
                parsedToken = jwtDecode(token);

                if (!tokenHasExpired(parsedToken)) {
                  _context2.next = 9;
                  break;
                }

                _context2.next = 9;
                return this.refreshToken();

              case 9:
                _context2.next = 16;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](4);
                // Token was invalid, logging out the user.
                this.updateToken('');
                this.redirectToSSO();
                return _context2.abrupt("return");

              case 16:
                this.isAuthenticated = true;

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 11]]);
      }));

      function checkToken() {
        return _checkToken.apply(this, arguments);
      }

      return checkToken;
    }() // eslint-disable-next-line @typescript-eslint/no-explicit-any

  }, {
    key: "get",
    value: function get(endpoint) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return this.request('get', endpoint, data);
    } // eslint-disable-next-line @typescript-eslint/no-explicit-any

  }, {
    key: "post",
    value: function post(endpoint, data) {
      return this.request('post', endpoint, data);
    } // eslint-disable-next-line @typescript-eslint/no-explicit-any

  }, {
    key: "put",
    value: function put(endpoint, data) {
      return this.request('put', endpoint, data);
    } // eslint-disable-next-line @typescript-eslint/no-explicit-any

  }, {
    key: "patch",
    value: function patch(endpoint, data) {
      return this.request('patch', endpoint, data);
    } // eslint-disable-next-line @typescript-eslint/no-explicit-any

  }, {
    key: "delete",
    value: function _delete(endpoint) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return this.request('delete', endpoint, data);
    }
  }, {
    key: "login",
    value: function () {
      var _login = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(code) {
        var _yield$this$request, token;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.request('post', '/authentication/getToken', {
                  code: code,
                  redirect_uri: this.getRedirectUri()
                }, false);

              case 2:
                _yield$this$request = _context3.sent;
                token = _yield$this$request.access_token;
                token && this.updateToken(token);
                return _context3.abrupt("return", token);

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function login(_x3) {
        return _login.apply(this, arguments);
      }

      return login;
    }()
  }, {
    key: "logout",
    value: function () {
      var _logout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.request('get', '/authentication/logout', {}, false);

              case 2:
                this.updateToken('');
                this.redirectToSSO(true);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function logout() {
        return _logout.apply(this, arguments);
      }

      return logout;
    }()
  }, {
    key: "refreshToken",
    value: function () {
      var _refreshToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _yield$this$request2, token;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.request('post', '/authentication/refreshToken', {
                  redirect_uri: this.getRedirectUri()
                }, false);

              case 2:
                _yield$this$request2 = _context5.sent;
                token = _yield$this$request2.access_token;
                token && this.updateToken(token);

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function refreshToken() {
        return _refreshToken.apply(this, arguments);
      }

      return refreshToken;
    }()
  }, {
    key: "setSite",
    value: function setSite(site) {
      this.site = site;
    }
  }]);

  return Client;
}();

var client = new Client(backendBaseUrl, backendAuthBaseUrl, backendAuthClientId);
export default client;